import Menu from './loginPage.vue';

export default Menu;
